export default __webpack_public_path__ + "static/media/fxLose.aeccb56d.mp3";